import { Autocomplete, MenuItem, TextField } from "@mui/material";
import useRubros from "../hooks/rubros.hook";
import { IRubro } from "../types/producto";

interface DesplegableRubrosProps {
  rubros: IRubro[];
  onChange: (param?: any) => void;
  handleFormSubmit?: () => void;
}

const DesplegableRubros = ({
  onChange,
  handleFormSubmit,
  rubros,
}: DesplegableRubrosProps) => {
  const rubrosFlatted = rubros
    .map((rubro: IRubro) => {
      if (rubro.rubros?.length > 0)
        return rubro.rubros.map((subrubros: IRubro) =>
          subrubros.rubros ? subrubros.rubros : subrubros
        );

      return rubro;
    })
    .flat(3);

  return (
    <Autocomplete
      options={rubrosFlatted}
      getOptionLabel={(rubro: IRubro) => rubro.nombreAnalytics || ""}
      onChange={onChange}
      renderInput={(params) => (
        <TextField
          {...params}
          onKeyPress={(e) =>
            e.key === "Enter" && handleFormSubmit && handleFormSubmit()
          }
          label="Rubro"
          variant="outlined"
        />
      )}
      renderOption={(props, rubro) => (
        <MenuItem {...props} value={rubro.idrubro}>
          {rubro.nombreAnalytics}
        </MenuItem>
      )}
    />
  );
};

export default DesplegableRubros;
